import { TwoColumnLayout } from '@/components/layouts/TwoColumnLayout'
import { WorkspaceGeneralSettings } from '@/components/Settings/General'
import { Users } from '@/components/Settings/Users/Users'
import { Route, Routes } from 'react-router-dom'

import { SettingsLeftNav } from '../components/Settings/SettingsLeftNav'

import type { FC } from 'react'

export const SettingsLeftNavRoutes: FC = () => {
	return (
		<Routes>
			<Route path="*" element={<SettingsLeftNav />} />
		</Routes>
	)
}

export const SettingsMainContentRoutes: FC = () => {
	return (
		<Routes>
			<Route path="general/*" element={<WorkspaceGeneralSettings />} />
			<Route path="users/*" element={<Users />} />
		</Routes>
	)
}

export const SettingsRoutes: FC = () => {
	return <TwoColumnLayout left={<SettingsLeftNavRoutes />} right={<SettingsMainContentRoutes />} />
}
